export default "/images/vendor/flag-icon-css/flags/1x1/ao.svg?ae9767d4b8d6c2fc991c41eea6238f16";